import { render, staticRenderFns } from "./product_package_agreement.vue?vue&type=template&id=2a6d97af&scoped=true&"
import script from "./product_package_agreement.vue?vue&type=script&lang=js&"
export * from "./product_package_agreement.vue?vue&type=script&lang=js&"
import style0 from "./product_package_agreement.vue?vue&type=style&index=0&id=2a6d97af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d97af",
  null
  
)

export default component.exports